module.exports = __webpack_public_path__ + "images/help/icn-faq-ding-341f6962db30708fe56f5cbbfa2b7915.png";